module.exports = __webpack_public_path__ + "static/SONO-12207-4bf5e06314a253d059933729ec54c28b.jpg";